import {
  Component,
  ChangeDetectionStrategy,
  ElementRef,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { GlassCardComponent } from '../../../shared/components/glass-card/glass-card.component';

@Component({
  selector: 'app-home-why-choose-us',
  standalone: true,
  imports: [CommonModule, GlassCardComponent],
  templateUrl: './home-why-choose-us.component.html',
  styleUrls: ['./home-why-choose-us.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeWhyChooseUsComponent implements OnInit, OnDestroy {
  features = [
    {
      icon: 'M12 2L2 7L12 12L22 7L12 2Z M2 17L12 22L22 17 M2 12L12 17L22 12',
      title: 'Full-Service Firm',
      description:
        'Our expert team manages everything from professional representation and maintenance schedules to closing ensuring a smooth transaction.',
      image: 'assets/images/yachts/azimut-77.jpg',
    },
    {
      icon: 'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z M12 6V12L16 14',
      title: 'Exclusive Brokerage Slips & Gulf Access',
      description:
        'Exclusive access to premier docking locations and luxury marina services with access to the Gulf of America.',
      image: 'assets/images/yachts/manhattan-68.jpg',
    },
    {
      icon: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z',
      title: 'Vast & Diverse Yacht Selection',
      description:
        'A handpicked fleet ranging from convertible sportfishing yachts and blue water sailing vessels to majestic superyachts.',
      image: 'assets/images/yachts/ferretti-920.jpg',
    },
    {
      icon: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z',
      title: 'Trusted Expertise',
      description: 'Years of experience in the yachting industry guaranteeing peace of mind.',
      image: 'assets/images/yachts/princess-v55.jpg',
    },
  ];

  isVisible = false;
  private observer: IntersectionObserver | undefined;

  constructor(
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {}

  private platformId = inject(PLATFORM_ID);

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.isVisible = true;
              this.cdr.markForCheck(); // Trigger change detection

              // Once visible, we can disconnect if we only want the animation once
              this.observer?.disconnect();
            }
          });
        },
        { threshold: 0.1 },
      );

      this.observer.observe(this.elementRef.nativeElement);
    } else {
      this.isVisible = true; // Default to visible on SSR
    }
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
